import React, {useState, useEffect} from "react"
import styled from "styled-components"
import WhoPay from "./WhoPay";
const Styled ={
    LittleTitleFont:styled.p`
        font-size:26px;
        font-family:"Jua", sans-serif;
        color:#000;
        font-weight: 500;
        text-align: center;
    `,
    Wrap:styled.div`
            width:400px;
            height:650px;
            display:flex;
            justify-content: space-around;
            align-items: center;
            flex-direction: column;
    `,
    BtnWrap:styled.div`
        width:100%;
        display:flex;
        justify-content: space-around;
        align-items: center;
        flex-wrap: wrap;
        flex-direction: row;
    `,
    Btn:styled.div`
        width:120px;
        height:45px;
        background-color:gold;
        border-radius: 10px;
        display:flex;
        justify-content: center;
        flex-direction:row;
        align-items: center;
        :hover{
            opacity:50%;
        }
    `,
    Fonts:styled.p`
        font-size:20px;
        font-weight: 500;
        font-family:"Jua", sans-serif;
    `,
}
interface PropsType {
    Points : number;
    setPoints : any;
    Solo_Duo: number;
    setSolo_Duo: any;
}
const Duo=(props:PropsType)=>{
    const [Page, setPage] = useState<boolean>(false)
    const setPoints = props.setPoints
    const Points = props.Points
    const Solo_Duo = props.Solo_Duo
    const setSolo_Duo = props.setSolo_Duo
    if(Page === false){
        return(
            <Styled.Wrap>
                <Styled.LittleTitleFont>결혼한지 얼마나 되셨나요?</Styled.LittleTitleFont>
                <Styled.BtnWrap>
                  <Styled.Btn
                      onClick={()=>{
                        setPoints(Points+3)
                        setPage(true)
                    }}
                  >
                      <Styled.Fonts>3년 미만</Styled.Fonts>
                  </Styled.Btn>
                  <Styled.Btn
                      onClick={()=>{
                        setPoints(Points+2)
                        setPage(true)
                     }}
                  >
                      <Styled.Fonts>5년 미만</Styled.Fonts>
                  </Styled.Btn>
                  <Styled.Btn
                      onClick={()=>{
                        setPoints(Points+1)
                        setPage(true)
                    }}
                  >
                      <Styled.Fonts>7년 미만</Styled.Fonts>
                  </Styled.Btn>
                </Styled.BtnWrap>
            </Styled.Wrap>
          )
    }else{
        return(
            <WhoPay 
                setPoints={setPoints}
                Points={Points}
                Solo_Duo={Solo_Duo}
                setSolo_Duo={setSolo_Duo}
            />
        )
    }
    
}

export default Duo